module.exports = __webpack_public_path__ + "static/music-republicain-5-242e5d6ed03bf5205dfa0c738fb0aadb.jpg";